import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: []
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState
});

const { reducer } = notificationSlice;

export default reducer;
